import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { LuBuilding2, LuTrophy } from "react-icons/lu";
import { FiUsers, FiShoppingCart } from "react-icons/fi";
import { Link } from 'react-router-dom';
import './AboutCompanySection.css';

const AboutCompanySection = () => {
    return (
        <section className="about-company">
            <Container>
                {/* Заголовок секции с синей линией */}
                <Row className="mb-4">
                    <Col className="text-md-start text-center">
                        <h2 className="section-title">О компании</h2>
                        <div className="blue-underline mx-md-0 mx-auto"></div>
                    </Col>
                </Row>
                
                {/* Описательный текст о компании */}
                <Row className="mb-4">
                    <Col className="section-description">
                        <p className="text-secondary">
                            ООО «Перформанс» с 2013 года является официальным дистрибьютором компании ООО «Исток Аудио Трейдинг» в ТО, ХМАО и ЯНАО.
                        </p>
                        
                        <p className="text-secondary">
                            Мы специализируемся на поставке и монтаже оборудования для людей с ограниченными возможностями здоровья и МГН в рамках государственной программы «Доступная среда».
                        </p>
                        
                        <p className="text-secondary mb-4">
                            Наша компания имеет богатый опыт работы с учреждениями социальной сферы, культуры, образования, здравоохранения и других.
                        </p>
                    </Col>
                </Row>
                
                {/* Статистические карточки */}
                <Row className="stats-cards">
                    {/* Карточка "Реализованных проектов" */}
                    <Col lg={3} md={6} sm={6} xs={12} className="mb-4">
                        <div className="stat-card d-flex flex-column align-items-center text-center p-4">
                            <FiUsers className="stat-icon mb-3" />
                            <h3 className="stat-number mb-2">100+</h3>
                            <p className="text-secondary">реализованных проектов</p>
                        </div>
                    </Col>
                    
                    {/* Карточка "Лет на рынке" */}
                    <Col lg={3} md={6} sm={6} xs={12} className="mb-4">
                        <div className="stat-card d-flex flex-column align-items-center text-center p-4">
                            <LuBuilding2 className="stat-icon mb-3" />
                            <h3 className="stat-number mb-2">10+</h3>
                            <p className="text-secondary">лет на рынке</p>
                        </div>
                    </Col>
                    
                    {/* Карточка "Сфер деятельности" */}
                    <Col lg={3} md={6} sm={6} xs={12} className="mb-4">
                        <div className="stat-card d-flex flex-column align-items-center text-center p-4">
                            <LuTrophy className="stat-icon mb-3" />
                            <h3 className="stat-number mb-2">7</h3>
                            <p className="text-secondary">сфер деятельности</p>
                        </div>
                    </Col>
                    
                    {/* Карточка "Товаров в каталоге" */}
                    <Col lg={3} md={6} sm={6} xs={12} className="mb-4">
                        <div className="stat-card d-flex flex-column align-items-center text-center p-4">
                            <FiShoppingCart className="stat-icon mb-3" />
                            <h3 className="stat-number mb-2">300+</h3>
                            <p className="text-secondary">товаров в каталоге</p>
                        </div>
                    </Col>
                </Row>
                
                {/* Кнопка "Подробнее о компании" */}
                <Row className="mt-4">
                    <Col className="text-center">
                        <Link to="/about">
                            <Button variant="outline-warning" className="rounded-pill more-btn px-4 py-2">
                                Подробнее о компании
                            </Button>
                        </Link>
                    </Col>
                </Row>
                {/* Горизонтальная палочка */}
                <Row className="mt-5">
                    <Col>
                        <hr className="horizontal-line" />
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default AboutCompanySection;